export const flattenObject = (
	inputObject: Record<string, unknown>,
	prefix = ''
): Record<string, unknown> => {
	if (!inputObject || typeof inputObject !== 'object') {
		return inputObject;
	}

	if (!inputObject) return {};

	const outputObject = Object.entries(
		inputObject as Record<string, unknown>
	)?.reduce<Record<string, unknown>>((acc, [key, value]) => {
		const keyPrefix = prefix ? `${prefix}__${key}` : key;
		if (value && typeof value === 'object') {
			const flattenedValue = flattenObject(
				value as Record<string, unknown>,
				keyPrefix
			) as Record<string, unknown>;
			return {
				...acc,
				...flattenedValue,
			};
		}
		return {
			...acc,
			[keyPrefix]: value,
		};
	}, {});

	return outputObject;
};

export const getUtm = () => {
	const queryParams = new URLSearchParams(window.location.search);
	return {
		utm_source: queryParams.get('utm_source') ?? 'UNK',
		utm_medium: queryParams.get('utm_medium') ?? 'UNK',
		utm_campaign: queryParams.get('utm_campaign') ?? 'UNK',
	};
};